@if(isEditMode) {
    <h2>Modifier un profil </h2>
} @else {
    <h2>Ajouter un profil </h2>
}
<mat-divider></mat-divider>

<form [formGroup]="profilForm">
    <div class="entite-section">
        <label>Entité :</label>
        <mat-form-field appearance="outline">
            <input type="text"
            placeholder="Entité"
            matInput
            formControlName="entite"
            [matAutocomplete]="auto">
            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn">
                @for(entite of filteredEntites  | async; track entite) {
                    <mat-option [value]="entite">
                        {{ entite.libelle }} ({{ getInterneExterneLabel(entite.interne) }})
                    </mat-option>
                }
            </mat-autocomplete>
          </mat-form-field>
    </div>

    <div class="profil-section">
        <label>Sélection Profil(s) :</label>
        <mat-form-field appearance="outline">
            <mat-select formControlName="profils" multiple placeholder="Profils">
                @for(profil of profilsOptions| async; track profil) {
                    <mat-option [value]="profil.id">
                        {{ profil.libelle_profil }}
                    </mat-option>
                }
            </mat-select>
          </mat-form-field>
    </div>

    <div class="actions">
            <button mat-raised-button (click)="closeDialog()" cdkFocusInitial>ANNULER</button>
            <button mat-raised-button class="button-validate" (click)="submitDialog()">ENREGISTRER</button>
    </div>
</form>